import { render, staticRenderFns } from "./HistorialMovimientosDialogComponent.vue?vue&type=template&id=156b170e&scoped=true"
import script from "./HistorialMovimientosDialogComponent.vue?vue&type=script&lang=js"
export * from "./HistorialMovimientosDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./HistorialMovimientosDialogComponent.vue?vue&type=style&index=0&id=156b170e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b170e",
  null
  
)

export default component.exports